import { notificationActionTypes } from './constants';

export function createNotification(
	title?: string,
	subtitle?: string | null,
	error?: boolean,
	timeout?: number,
	clearPreviously?: boolean,
) {
	return {
		type: notificationActionTypes.CREATE_NOTIFICATION_MESSAGE,
		payload: {
			title,
			subtitle,
			error,
			timeout,
			clearPreviously,
		},
	};
}

export function closeNotification(id: string | number) {
	return {
		type: notificationActionTypes.NOTIFICATION_MESSAGE_CLOSE,
		payload: {
			id,
		},
	};
}

export function clearNotification() {
	return {
		type: notificationActionTypes.CLEAR_STATE,
	};
}
